import React from "react";
import { Typography, List, ListItem, Container, Box } from "@mui/material";
import CustomHelmet from "../../common/CustomHelmet";

const SexTherapyForCouples = () => {
  return (
    <>
      <CustomHelmet
        title="Couple's Sex Therapy - Dr. Anne Rothenberg"
        description="Expert couple's sex therapy with Dr. Anne Rothenberg. Address issues like mismatched desires, erectile dysfunction, and communication problems to enhance intimacy and sexual satisfaction."
        keywords="sex therapy for couples, couple's sexual health, sexual satisfaction counseling, Orlando sex therapy, unhappy marriage, sexologist, sexless marriage help"
        ogTitle="Improve Your Intimate Relationship with Couple's Sex Therapy"
        ogDescription="Dr. Anne Rothenberg provides specialized sex therapy for couples looking to overcome challenges and enhance their intimate connections. Explore therapy options today."
        ogUrl="https://drannerothenberg.com/services/sex-therapy-for-couples"
      />
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            textAlign: "left",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h4" gutterBottom>
            Sex Therapy for Couples
          </Typography>

          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: "#555", mb: 3 }}
          >
            Dr. Anne Rothenberg understands that talking about sexual concerns
            takes courage. As an experienced sex therapist, she creates a
            comfortable, non-judgmental space where couples can openly discuss
            their intimate lives. Whether you're dealing with a complete loss of
            desire, painful intercourse, or simply feeling disconnected from
            your partner, Dr. Rothenberg helps couples rediscover intimacy and
            build a satisfying sex life that works for both partners.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: { xs: 2, md: 3 },
              fontStyle: "italic",
              color: "#666",
              fontSize: { xs: "0.9rem", md: "1rem" },
              padding: { xs: "12px", md: "16px" },
              backgroundColor: "rgba(228, 181, 162, 0.05)",
              borderRadius: "8px",
              borderLeft: "4px solid #E4B5A2",
            }}
          >
            Remember: Sexual difficulties are incredibly common. Research shows
            that 43% of women and 31% of men experience sexual challenges at
            some point. You're not alone, and these issues can be resolved with
            the right support.
          </Typography>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            "We've Lost That Spark" - Desire and Connection Issues
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "We haven't had sex in months (or years)"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My partner wants sex all the time, I never do"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm always initiating - I'm tired of being rejected"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Sex feels like another chore on my to-do list"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We're like roommates, not lovers"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I love my partner but I'm not 'in love' anymore"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Work stress has killed my sex drive"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm too exhausted for intimacy"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We don't feel emotionally connected anymore"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My partner doesn't understand - it's not them, it's me"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Physical and Performance Concerns
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "I can't maintain an erection"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I orgasm too quickly"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've never had an orgasm with my partner"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Sex is painful but I don't want to disappoint my partner"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm so anxious about performing that I avoid sex"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My medication killed my ability to orgasm"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I can't get aroused anymore"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Menopause has changed everything"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm worried I'm broken"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Body Image and Self-Esteem
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "I hate my postpartum body"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I've gained weight and feel unsexy"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm grieving my pre-baby body"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I don't want to be touched or seen naked"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Surgery/illness changed how I see myself"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I compare myself to porn stars"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Aging makes me feel undesirable"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My partner's comments hurt my confidence"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Communication and Emotional Barriers
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "We can't talk about sex without fighting"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I don't know how to tell them what I need"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I fake orgasms to avoid hurting their feelings"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Unresolved anger is blocking our intimacy"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "I'm too embarrassed to share my fantasies"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Past trauma makes intimacy scary"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Religious guilt affects our sex life"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We have different ideas about what's 'normal'"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Modern Challenges and External Factors
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "Porn has created unrealistic expectations"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "My partner chooses porn over me"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Dating apps make me wonder what I'm missing"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Social media affects how I see our relationship"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We're too tired after dealing with kids all day"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Working from home killed our romance"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Financial stress is affecting our intimacy"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We have no privacy with family living with us"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 3 }}
          >
            Exploring and Growing Together
          </Typography>
          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              "We want to try new things but don't know how to start"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "Our sex life has become boring and predictable"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We have different comfort levels with experimentation"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "How do we keep passion alive after 20 years?"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "We want to discuss opening our relationship"
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              "How do we navigate different kinks/interests?"
            </ListItem>
          </List>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#4A90E2", mt: 4 }}
          >
            What Sex Therapy Actually Involves
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            Many couples worry about what happens in sex therapy. Let's be
            clear:
          </Typography>

          <List
            dense
            sx={{
              listStyleType: "disc",
              pl: 4,
              color: "#333",
              textAlign: "left",
              mb: 3,
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              You keep your clothes on - it's talk therapy in a safe, private
              setting
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              We focus on communication, understanding, and practical solutions
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              You may receive "homework" exercises to try at home privately
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              We work at your pace - there's no pressure to do anything you're
              not ready for
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Everything discussed is completely confidential
            </ListItem>
          </List>

          <Typography
            variant="body1"
            sx={{ mt: 3, fontWeight: "bold", color: "#4A90E2" }}
          >
            Many couples find that even one session helps them start
            communicating more openly.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default SexTherapyForCouples;
